<p-dialog [(visible)]="visible" [styleClass]="classes" [header]="header" [modal]="modal" [closable]="closable" [draggable]="draggable"
  [resizable]="resizable" [closeOnEscape]="closeOnScape" [style]="styles" (onHide)="onHide()">
  <ng-template pTemplate="header" *ngIf="pHeader">
    <ng-content select="[dialog-header]"></ng-content>
  </ng-template>
  <ng-content></ng-content>
  <ng-template pTemplate="footer" *ngIf="pFooter">
    <ng-content select="[dialog-footer]"></ng-content>
  </ng-template>
</p-dialog>
